import React from "react";
import { Toggle } from "../../../design-system";
import InfoIcon from "../InfoIcon";
import { typography, textColors } from "../../../design-system/tokens";

/**
 * SwitchField — labelled toggle control.
 *
 * Layout depends on whether the field has the whole line to itself:
 *
 *   - **Standalone (full line):** label hugs the left edge and the
 *     toggle is pushed to the far right (``justify-between``) — the
 *     conventional settings-row look.
 *
 *   - **Sharing a line (``sharesRow``):** when the edit-panel grid packs
 *     this switch onto a multi-column line alongside other fields, the
 *     column is narrow and a far-right toggle reads as disconnected from
 *     its label. Here the toggle sits immediately after the text and the
 *     leftover space trails after it (``justify-start``), keeping the
 *     label↔toggle pairing tight.
 */
export const SwitchField = ({ value, onChange, label, help, infoText, sharesRow = false }) => (
  <div
    className={`edit-field-row switch-field-row w-full items-center gap-3 space-x-0 py-1.5 ${
      sharesRow ? "justify-start" : "justify-between"
    }`}
  >
    <div className={sharesRow ? "min-w-0" : "min-w-0 flex-1"}>
      {label && (
        <div className={`${typography.label} ${textColors.secondary} inline-flex items-center`}>
          <span className="select-none">{label}</span>
          {infoText ? <span className="ml-2"><InfoIcon text={infoText} /></span> : null}
        </div>
      )}
      {help && <div className={`${typography.caption} ${textColors.tertiary} mt-0.5`}>{help}</div>}
    </div>
    <Toggle
      checked={Boolean(value)}
      onChange={(e) => onChange(e.target.checked)}
      aria-label={label || "Toggle"}
      className="shrink-0"
    />
  </div>
);
